/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import incorrectPenaltySectionStyle from "./incorrectPenaltySectionStyle";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconDocuments from "../../../../assets/icons/generic/IconDocuments";

const IncorrectPenaltySection = () => {
  return (
    <Container sx={incorrectPenaltySectionStyle.container}>
      <Typography variant={"h3"} component={"h2"} sx={incorrectPenaltySectionStyle.heading}>
        Jeder zweite Bußgeldbescheid ist fehlerhaft
      </Typography>
      <Grid container sx={incorrectPenaltySectionStyle.gridContainer}>
        <Grid
          sx={incorrectPenaltySectionStyle.imageContainer}
          size={{
            xs: 12,
            sm: 4
          }}>
          <IconDocuments sx={{ ...incorrectPenaltySectionStyle.img }} />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 8
          }}>
          <Box sx={incorrectPenaltySectionStyle.text}>
            <Typography variant={"h5"} component={"h3"}>Ihre Chancen für einen Einspruch stehen gut!</Typography>
            <Typography>
              In einer Studie der VUT-Sachverständigengesellschaft von 2013 waren <strong>56 Prozent der Bescheide fehlerhaft </strong>
              und nur 44 Prozent von 15 000 Bußgeldvorgängen fehlerfrei.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default IncorrectPenaltySection;
